export enum PreferenceTab {
  PersonalInfo = 0,
  Notifications = 1
}
